// TRIPS: who manages trips is the role's `trips` tick (owner 2 Nov 2026,
// Company Settings > Permissions; it was TRIP_MANAGER_ROLES); a Manager reads
// the events they lead. No imports: the always-loaded sidebar uses it
// without the Trips code.
export const TRIPS_FEATURE = 'trips';

/** The roles that managed trips before the tick (kept for reference). */
export const TRIP_MANAGER_ROLES = [
  'Company Owner',
  'Administrative',
  'Backoffice',
  'Site Admin',
];

/** Whether the role holds the `trips` tick (manages trips). */
export const hasTripsTick = (features?: readonly string[] | null) =>
  Boolean(features?.includes(TRIPS_FEATURE));

/** Who may open the office Trips screens at all: the `trips` tick, or a
 * Manager (limited to the events they lead). */
export const isTripsRole = (
  role?: string | null,
  features?: readonly string[] | null
) => hasTripsTick(features) || role === 'Manager';

/**
 * Who plans trips (the team view behind "Trips"): the `trips` tick always;
 * a Manager only while leading an event (`leadsEvent` from has-sent).
 * Before the answer arrives a Manager is not a planner yet; if Main does
 * not send it (older build or an error), a Manager plans as before.
 */
export const canPlanTrips = (
  role: string | null | undefined,
  answer: { leadsEvent?: boolean } | undefined,
  features?: readonly string[] | null
) =>
  hasTripsTick(features) ||
  (role === 'Manager' && answer !== undefined && answer.leadsEvent !== false);
